// Node Modules
import axios from 'axios'

export function largeImage(src: string): Promise<string> {
  const index = src.lastIndexOf('.')
  const largeSrc = src.slice(0, index) + '_large' + src.slice(index)

  return axios
    .head(largeSrc, { baseURL: '.' })
    .then(result => largeSrc)
    .catch(() => src)
}